import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogLocalComponent } from './dialog-local/dialog-local.component';
import { TableHeader } from '../../../shared/models/table-header';
import { Local } from '../../../shared/models/local';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { TableComponent } from '../../../shared/components/table/table.component';
import { ToastService } from '../../../shared/services/toast.service';
import { ModalService } from '../../../shared/services/modal.service';
import { LocalService } from '../../../shared/services/local.service';
import { ToastState as ts } from '../../../shared/enums/toast-state.enum';
import { ButtonVariant } from '../../../shared/enums/button-variant.enum';

@Component({
  selector: 'app-local',
  imports: [ButtonComponent, TableComponent, FormsModule],
  templateUrl: './local.component.html',
  styleUrl: './local.component.scss',
})
export class LocalComponent {
  localsList: Local[] = [];
  headers: TableHeader[] = [
    { value: 'id', label: 'ID' },
    { value: 'nome', label: 'Local' },
  ];

  nome: string = '';

  constructor(
    private toast: ToastService,
    private service: LocalService,
    private dialog: MatDialog,
    private modal: ModalService,
  ) {}

  ngOnInit() {
    this.loadLocalsList();
  }

  loadLocalsList() {
    this.service.getAll().subscribe({
      next: (value) => {
        if (value && value.content) {
          this.localsList = [...value.content];
        }
      },
      error: (e) => {
        this.toast.showToast(
          ts.error,
          e.error[0] ?? 'Não foi possível carregar os locais.',
        );
      },
    });
  }

  create() {
    const dialogRef = this.dialog.open(DialogLocalComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Local salvo!');
        this.localsList = [...this.localsList, result];
      }
    });
  }

  edit(item: Local) {
    const data = {
      local: item,
    };

    const dialogRef = this.dialog.open(DialogLocalComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toast.showToast(ts.success, 'Local atualizado!');
        const index = this.localsList.findIndex((obj) => obj.id == result.id);
        if (index != -1) {
          this.localsList[index] = result;
          this.localsList = [...this.localsList];
        }
      }
    });
  }

  confirmDelete(item: Local) {
    const dialog = this.modal.openConfirmationModal(
      'Exclusão de local',
      'Deseja mesmo excluir?',
      'Excluir',
      ButtonVariant.d,
      'Cancelar',
      ButtonVariant.s,
    );
    dialog.subscribe((result) => {
      if (result) {
        this.delete(item.id);
      }
    });
  }

  delete(id: number) {
    this.service.delete(id).subscribe({
      next: () => {
        this.toast.showToast(ts.success, 'Local deleted.');
        this.localsList = this.localsList.filter((item) => item.id !== id);
      },
      error: (e) => {
        this.toast.showToast(ts.error, e.error[0]);
      },
    });
  }
}
